import { environment } from 'src/environments/environment';
export class Variables {
    pass = '#ranitessarldev2020';
    realm = environment.realm;
    clientid = environment.clientid;
}
